import React from 'react';
import { TIME_RANGES } from '../../../utils/sensorConfig';

export default function RangeSelectorRow({ rangeKey, setRangeKey, rangeLabel, launchDate, prefetching }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 500, color: '#1e293b' }}>
          Range: <strong>{rangeLabel}</strong>
        </span>
        {rangeKey === 'launch' && launchDate && (
          <span style={{ fontSize: 13, color: '#94a3b8' }}>
            ({new Date(launchDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })})
          </span>
        )}
        {prefetching && (
          <div style={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid #e2e8f0', borderTopColor: '#64748b', animation: 'spin 0.8s linear infinite' }} />
        )}
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        {TIME_RANGES.map(r => (
          <button key={r.key} onClick={() => setRangeKey(r.key)} style={{
            padding: '6px 14px', borderRadius: 100, fontSize: 13, fontWeight: rangeKey === r.key ? 600 : 400, cursor: 'pointer',
            background: rangeKey === r.key ? '#1e293b' : '#fff',
            color: rangeKey === r.key ? '#fff' : '#64748b',
            border: rangeKey === r.key ? 'none' : '1px solid #e2e8f0',
          }}>{r.label}</button>
        ))}
      </div>
    </div>
  );
}
